module.exports = __webpack_public_path__ + "static/media/dendrogram.1a611622.md";